import { Command } from './command.type';
import { Condition } from './condition.model';

export class HasConditions {
  visibleWhen: (Condition | Command)[];
  selectedWhen: (Condition | Command)[];
  visible: boolean;
}
